import { render } from "./Calificaciones.vue?vue&type=template&id=8a7f6f14"
import script from "./Calificaciones.vue?vue&type=script&lang=js"
export * from "./Calificaciones.vue?vue&type=script&lang=js"

import "./Calificaciones.vue?vue&type=style&index=0&id=8a7f6f14&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__